import { Topic } from "./../models/excel.model";

export class ParserService {
  private trim(val: string | null) {
    if (val) {
      return val.trim();
    }

    return null;
  }

  private getTree(rows: (string | null)[][]) {
    const topics: Topic[] = [];

    let topicIndex = -1;
    let categoryIndex = -1;
    let requirementIndex = -1;

    for (const row of rows) {
      const topic = this.trim(row[0]);
      const category = this.trim(row[1]);
      const requirement = this.trim(row[2]);
      const prefix = this.trim(row[3]);
      const question = this.trim(row[4]);

      if (topic) {
        topicIndex = topics.findIndex((t) => t.title === topic);

        if (topicIndex === -1) {
          topicIndex = topics.push({ title: topic, categories: [] }) - 1;
        }
      }

      if (category) {
        categoryIndex = topics[topicIndex].categories.findIndex(
          (c) => c.title === category
        );

        if (categoryIndex === -1) {
          categoryIndex =
            topics[topicIndex].categories.push({
              title: category,
              requirements: [],
            }) - 1;
        }
      }

      if (requirement) {
        requirementIndex = topics[topicIndex].categories[
          categoryIndex
        ].requirements.findIndex((r) => r.title === requirement);

        if (requirementIndex === -1) {
          requirementIndex =
            topics[topicIndex].categories[categoryIndex].requirements.push({
              title: requirement,
              questions: [],
            }) - 1;
        }
      }

      if (prefix || question) {
        topics[topicIndex].categories[categoryIndex].requirements[
          requirementIndex
        ].questions.push({
          prefix: prefix,
          question: question,
        });
      }
    }

    return topics;
  }

  public async hashFileSHA256(file: File) {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  }

  public async parseExcelToJson(file: File) {
    const buffer = await file.arrayBuffer();

    const XLSX = await import("xlsx");

    const workbook = XLSX.read(buffer, { type: "array" });

    const items: { sheetName: string; topics: Topic[] }[] = [];

    for (const sheetName of workbook.SheetNames) {
      const sheet = workbook.Sheets[sheetName];

      const data = XLSX.utils.sheet_to_json<(string | null)[]>(sheet, {
        header: 1, // array-of-arrays
        defval: null, // preserve empty cells
      });

      const topics = this.getTree(data);

      items.push({
        sheetName: sheetName,
        topics: topics,
      });
    }

    return items;
  }
}

export const parserService = new ParserService();
